// extracted by mini-css-extract-plugin
export default {"samimg":"demo_samimg__RVryW","sbox":"demo_sbox__BhZXN","links":"demo_links__ob79S","schedule":"demo_schedule__BSVmb"};